import { render, staticRenderFns } from "./AddressFormPart.vue?vue&type=template&id=46b1ab8d&scoped=true"
import script from "./AddressFormPart.vue?vue&type=script&lang=js"
export * from "./AddressFormPart.vue?vue&type=script&lang=js"
import style0 from "./AddressFormPart.vue?vue&type=style&index=0&id=46b1ab8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1ab8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VRow,VTextField})
